import { createServer } from "miragejs";

import { APPLICATION } from "#/constants";

import { routes } from "./routes";
import { getToken } from "./utils";

type MakeServerProps = {
  environment?: typeof process.env.NODE_ENV;
  userName?: string;
  userRoles?: string[];
};

/**
 * @function startApiMockServer
 * @description function that starts a MirageJS Mock Server
 * @param environment - Environment type
 * @param userName - Custom user name that will be stored in window object
 * @param userRoles - Custom user roles to test different authentication scenarios
 * @returns Server
 */
export const startApiMockServer = ({
  environment = "test",
  userName = "mock_user",
  userRoles = [],
}: MakeServerProps) => {
  const token = getToken(userName, userRoles);

  return createServer({
    environment,
    trackRequests: true,
    urlPrefix: APPLICATION.BFF_URL,
    routes() {
      routes(this, token);
    },
  });
};
